import apiClient from '../middleware/apiClient';
import { SIK_ORDER, COTTON_SIK_ORDER } from '../helpers/apis';
import { callApiWithFallback } from '../helpers/apiFallback';
import cottonFlagManager from '../helpers/featureFlags/cotton';
import { kibanaLog } from '../helpers/logger';

export const GET_SIK_ORDER = 'GET_SIK_ORDER';
export const GET_SIK_ORDER_SUCCESS = 'GET_SIK_ORDER_SUCCESS';
export const GET_SIK_ORDER_FAILURE = 'GET_SIK_ORDER_FAILURE';

function dispatchGetSikOrder(endpoint = SIK_ORDER) {
  return {
    type: GET_SIK_ORDER,
    payload: apiClient.fetch(endpoint),
  };
}

function dispatchGetSikOrderSuccess(data) {
  return {
    type: GET_SIK_ORDER_SUCCESS,
    payload: data,
  };
}

function dispatchGetSikOrderFailure(error) {
  return {
    type: GET_SIK_ORDER_FAILURE,
    payload: error,
  };
}

export const getSikOrder = () => async (dispatch, getState) => {
  const { sik = {} } = getState();
  if (sik.requested) {
    return null;
  }

  try {
    let response;
    const { isAptV1Enabled, sikOrderEnabled } = cottonFlagManager;

    if (isAptV1Enabled) {
      // Use APT V1 API (100% Kotlin)
      kibanaLog('cotton_sik_order_api_called');
      response = await dispatch(dispatchGetSikOrder(COTTON_SIK_ORDER)).payload;
    } else if (sikOrderEnabled) {
      // Try Cotton API, fallback to Ruby API
      response = await callApiWithFallback(
        dispatch,
        () => dispatchGetSikOrder(COTTON_SIK_ORDER),
        () => dispatchGetSikOrder(SIK_ORDER),
        'sik_order',
      );
    } else {
      // Only call Ruby API
      response = await dispatch(dispatchGetSikOrder()).payload;
    }
    return dispatch(dispatchGetSikOrderSuccess(response));
  } catch (error) {
    return dispatch(dispatchGetSikOrderFailure(error));
  }
};
